import useDefinedContext from "hooks/useDefinedContext";
import MultiSelectContext from "../MultiSelectContext";

function useMultiSelectIds() {
  return useDefinedContext(MultiSelectContext);
}

export default useMultiSelectIds;
